import LazyHydrate from "@components/utils/LazyHydrate";

import * as Styled from "./styles";
import { TechStackProps } from "./types";

const TechStack: React.FC<TechStackProps> = ({ items }) =>
  items && items.length ? (
    <LazyHydrate
      useDisplayContents={false}
      whenVisible
      getEventTarget={() => window}
    >
      <Styled.List aria-label="Technology icons">
        {items &&
          items.length &&
          items.map((item) => (
            <li key={item}>
              <Styled.Icon src={item} />
            </li>
          ))}
      </Styled.List>
    </LazyHydrate>
  ) : null;

export default TechStack;
